import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const getFacebookPixel = () => {
  if (typeof window === 'undefined') return null;

  return window.fbq || null;
};

export const extractUserProperties = (user) => {
  if (!user) return {};

  const { id, attributes } = user;
  const { email, profile } = attributes || {};
  const { firstName, lastName } = profile || {};

  return {
    custom_property_user_id: id.uuid,
    custom_property_user_email: email,
    custom_property_firstName: firstName,
    custom_property_lastName: lastName,
  };
};

const useFacebookPixel = () => {
  const currentUser = useSelector((state) => state.user.currentUser);

  const track = useCallback(
    (event, customProperties) => {
      const fbq = getFacebookPixel();
      if (!fbq) return;
      const userProperties = extractUserProperties(currentUser);
      const properties = { ...userProperties, ...customProperties, agent: navigator.userAgent };
      fbq('track', event, properties);
    },
    [currentUser]
  );

  return { track };
};

export default useFacebookPixel;
